import React, { useState } from "react";
import {
  Divider,
  IconButton,
  SwipeableDrawer,
  Stack,
  Box,
  Link,
  Typography,
} from "@mui/material";
import { ChevronRight, Menu, Phone, Email } from "@mui/icons-material";

export const MobileAppbar = ({ func, translate, pages }) => {
  const [open, setOpen] = useState(false);
  const handleChangeLanguage = (lang) => {
    // setLanguage(lang);
    func(lang);
  };
  return (
    <Stack direction="row" sx={{ display: { xs: "flex", md: "none" } }}>
      <Box
        flex={1}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        padding={1}
      >
        <img
          src="/images/SBP_CONLogo_trans.png"
          alt="logo company"
          width="80vw"
          height="80vh"
        />
      </Box>
      <Stack direction="column" flex={2} justifyContent="center">
        <Link
          href="mailto:sale@sbpcon.co.th"
          underline="none"
          color="white"
          display="flex"
          alignItems="center"
          sx={{
            "&:hover": {
              color: "#669944",
            },
            my: 1,
          }}
        >
          <Email style={{ marginRight: "5px" }} size="small" />
          <Typography variant="body2">{translate("SALE_EMAIL")}</Typography>
        </Link>
        <Link
          href="tel:0986264569"
          underline="none"
          color="white"
          display="flex"
          alignItems="center"
          sx={{
            "&:hover": {
              color: "#669944",
            },
            my: 1,
          }}
        >
          <Phone style={{ marginRight: "5px" }} size="small" />
          <Typography variant="body2">{translate("SALE_PHONE")}</Typography>
        </Link>
      </Stack>
      <Stack direction="column">
        <Box color="white">
          <Box sx={{ display: "flex" }}>
            <IconButton
              size="large"
              color="inherit"
              aria-label="menu"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
              onClick={() => handleChangeLanguage("th")}
            >
              <img
                src="/images/thailand.png"
                alt="Thailand Language"
                width={25}
                height={20}
              />
            </IconButton>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ border: "1px solid #669944" }}
            />
            <IconButton
              size="large"
              color="inherit"
              aria-label="menu"
              onClick={() => handleChangeLanguage("en")}
            >
              <img
                src="/images/united-kingdom.png"
                alt="Thailand Language"
                width={25}
                height={20}
              />
            </IconButton>
          </Box>
        </Box>
        <Box
          color="white"
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <IconButton
            size="large"
            color="inherit"
            onClick={() => setOpen(true)}
          >
            <Menu />
          </IconButton>
          <SwipeableDrawer
            anchor="right"
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            // sx={{ "& .MuiDrawer-root": { backgroundColor: "black" } }}
            PaperProps={{
              sx: {
                backgroundColor: "rgba(0,0,0,0.9)",
                width: "35%",
                padding: "15px",
              },
            }}
          >
            <div>
              <IconButton
                onClick={() => setOpen(false)}
                sx={{
                  "&:hover": {
                    color: "#669944",
                  },
                }}
              >
                <Typography variant="body1" color="white">
                  {translate("CLOSE")}
                </Typography>
                <ChevronRight sx={{ color: "white" }} />
              </IconButton>
            </div>
            <Divider sx={{ backgroundColor: "white", my: 3 }} />
            <Stack direction="column">
              {pages.map((page) => (
                <Link
                  href={`#${page}`}
                  key={page}
                  underline="none"
                  sx={{
                    color: "white",
                    display: "block",
                    padding: { xs: "8px 5px", lg: "32px 20px" },
                    "&:hover": {
                      color: "#669944",
                    },
                  }}
                  onClick={() => setOpen(false)}
                >
                  {translate(`${page}`)}
                </Link>
              ))}
            </Stack>
          </SwipeableDrawer>
        </Box>
      </Stack>
    </Stack>
  );
};
